import { TipoSuministroTramiteEnergiaEnum, type CoordenadaFirma, type CreateServicioEndesaModel, type DescuentoEnergiaModel, type DetailServicioEndesaModel, type ServicioEndesaModel, type VariableAnexoValor } from '@api/api';
import { toUTCDateOnly } from '@helpers/date-parser-helper';
import { DatosServicioEndesa } from './DatosServicioEndesa';

export class CreateServicioEndesa implements CreateServicioEndesaModel {

  IdEmpresaServicios: string = '';
  Nombre: string = '';
  FechaInicio: Date = new Date();
  FechaFin: Date = new Date();
  TipoEnergia: TipoSuministroTramiteEnergiaEnum = TipoSuministroTramiteEnergiaEnum.Luz;
  Descripcion: string = '';
  Coste: number = 0.0;
  AplicaPersonaFisica: boolean = false;
  AplicaPersonaJuridica: boolean = false;
  Excluyente: boolean = false;
  Observaciones: string | null = null;
  Activa: boolean = true;
  CoordenadasFirma: CoordenadaFirma[] = [];
  EmpresaServicios: string = '';
  DenominacionInterna: string = '';
  DatosEndesa: ServicioEndesaModel;
  Descuentos: DescuentoEnergiaModel[] = [];
  IdAnexoEmpresaServicios: string | null = null;
  VariablesAnexo: VariableAnexoValor[] | null = null;

  constructor(data?: Partial<CreateServicioEndesa>) {
    Object.assign(this, data);

    if (data?.FechaFin == null)
      this.FechaFin.setDate(this.FechaFin.getDate() + 1)

    this.FechaInicio = toUTCDateOnly(this.FechaInicio);
    this.FechaFin = toUTCDateOnly(this.FechaFin);

    this.DatosEndesa = new DatosServicioEndesa();
  }

  public createFromServicioDetail(oferta: DetailServicioEndesaModel): CreateServicioEndesa {
    Object.assign(this, oferta);
    return this;
  }

}